const config = {
    apiEndpoint: "https://data-nest.vercel.app",
    version: "v1",
};

export default config;